import { ProductReference } from '../../core/api/products/entities/product-reference.entity';
import { FormOptions } from './base.form-options';

export class ProductFormOptions extends FormOptions {
  products: ProductReference[] = [];
}
